import { Directive } from '@angular/core';

@Directive({
  selector: '[appGuideCardTitle]',
})
export class GuideCardTitleDirective {}
